import * as React from "react";

import Zone from "@insite/client-framework/Components/Zone";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Link, { StyledIcon } from "@insite/mobius/Link";
import { MainNavigationStyles, MappedLink } from "@tIntermatic/Overrides/Widgets/Header/MainNavigation";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Menu from "@insite/mobius/Menu";
import { css, ThemeProps, withTheme } from "styled-components";

interface MainNavigationItemProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    viewAllCategoryLink: PageLinkModel | undefined;
    id: string;
    // customMenu: boolean;
}

interface State {
    hover: boolean;
}

class MainNavigationItem extends React.Component<ThemeProps<BaseTheme> & MainNavigationItemProps, State> {
    element = React.createRef<HTMLElement>();
    popover = React.createRef<HTMLUListElement>();

    constructor(props: ThemeProps<BaseTheme> & MainNavigationItemProps) {
        super(props);

        this.state = {
            hover: false,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount(): void {
        setMainNavigation({
            close: () => {
                this.closePopover();
            },
            openMenu: (index: number) => {
                this.openPopover();
            },
        });
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    hoverOn = () => {
        this.setState({ hover: true });
    };

    hoverOff = () => {
        this.setState({ hover: false });
    };
    render() {
        const {
            styles,
            link,
            index,
            id,
            viewAllCategoryLink,
            theme: {
                breakpoints: { maxWidths },
            },
        } = this.props;
        const downIcon = <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />;
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading = hasChildren && link.childrenType === "CascadingMenu";
        const isMega = hasChildren && link.childrenType === "MegaMenu";
        const isCustom = link.CustomMenu;
        const emptyLi = [];
        if (link.children) {
            const childrenLength = link.children.filter(child => !child.excludeFromNavigation).length;
            if (childrenLength < 7) {
                for (let i = childrenLength; i <= 6; i++) {
                    emptyLi.push(<li>&nbsp;</li>);
                }
            }
        }

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={link.isClickable === undefined || link.isClickable ? link?.url : ""}
                target={link.openInNewWindow ? "_blank" : ""}
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if ((!isCustom && isMega) || link.url === "") {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    color={styles.menuItemTypography?.color}
                    {...styles.menuItem}
                >
                    {link.title}
                    {(isCascading || isMega || isCustom) && downIcon}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (!isCustom && isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            menuItem = (
                <Menu
                    descriptionId={`${link.title}_${index}`}
                    menuItems={link.children}
                    className="cascading-menu"
                    menuTrigger={menuLink}
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }
        if (isMega || isCustom) {
            menuItem = (
                <StyledWrapper
                    {...styles.megaMenuWrapper}
                    className="mega-menu"
                    onMouseOver={this.hoverOn}
                    onClick={() => {
                        this.setState({ hover: !this.state.hover });
                    }}
                    onMouseOut={this.hoverOff}
                >
                    <Link
                        typographyProps={styles.menuItemTypography}
                        color={styles.menuItemTypography?.color}
                        {...styles.menuItem}
                    >
                        {link.title}
                        {(isCascading || isMega || isCustom) && downIcon}
                    </Link>
                    <StyledWrapper
                        {...(this.state.hover
                            ? { ...(isMega ? { ...styles.openMegaMenu } : { ...styles.openCustomMegaMenu }) }
                            : { ...styles.closeMegaMenu })}
                        className="megaMenuDrawerWrapper"
                    >
                        {link.MegamenuCustomrow ? (
                            <StyledWrapper
                                css={css`
                                    width: 100%;
                                    display: flex;
                                    margin: 0 auto;
                                `}
                            >
                                <StyledWrapper
                                    css={css`
                                        width: 100%;
                                    `}
                                >
                                    <GridContainer
                                        {...styles.megaMenu4RowGridContainer}
                                        offsetProps={{ ...styles.megaMenu4RowGridContainer?.offsetProps, as: "ul" }}
                                    >
                                        {isCustom ? (
                                            <StyledWrapper
                                                css={css`
                                                    width: 100%;
                                                    min-height: 150px;
                                                `}
                                            >
                                                <Zone contentId={this.props.id} zoneName={`${link.title}1`}></Zone>
                                            </StyledWrapper>
                                        ) : (
                                            <>
                                                {link &&
                                                    link.children &&
                                                    link.children?.length > 0 &&
                                                    link
                                                        .children!.filter(child => !child.excludeFromNavigation)
                                                        .map((child, index) => (
                                                            // eslint-disable-next-line react/no-array-index-key
                                                            <GridItem
                                                                width={(12 / link.numberOfColumns!) as GridWidths}
                                                                // eslint-disable-next-line react/no-array-index-key
                                                                key={index}
                                                                {...styles.megaMenuGridItem}
                                                                as="li"
                                                            >
                                                                <Link
                                                                    {...styles.megaMenuHeading}
                                                                    href={child?.url}
                                                                    onClick={this.hoverOff}
                                                                >
                                                                    {child.title}
                                                                </Link>
                                                                {child.children && (
                                                                    <ul className="subCategoriesLink">
                                                                        {child.children
                                                                            .filter(
                                                                                grandChild =>
                                                                                    !grandChild.excludeFromNavigation,
                                                                            )
                                                                            .map((grandChild, index) => (
                                                                                // eslint-disable-next-line react/no-array-index-key
                                                                                <li key={index}>
                                                                                    <Link
                                                                                        {...styles.megaMenuLink}
                                                                                        className="mega-menu-link"
                                                                                        onClick={this.hoverOff}
                                                                                        href={grandChild?.url}
                                                                                    >
                                                                                        {grandChild.title}
                                                                                    </Link>
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                )}
                                                            </GridItem>
                                                        ))}
                                                {link.shopAllProduct && (
                                                    <GridItem key={index} {...styles.megaMenuGridItem} as="li">
                                                        <Link
                                                            {...styles.megaMenuHeading}
                                                            onClick={this.hoverOff}
                                                            href={link.url}
                                                        >
                                                            {link.shopAllProductLabel
                                                                ? `${link.shopAllProductLabel} ${link.title}`
                                                                : `Shop All ${link.title}`}
                                                        </Link>
                                                    </GridItem>
                                                )}
                                            </>
                                        )}
                                    </GridContainer>
                                </StyledWrapper>
                            </StyledWrapper>
                        ) : (
                            <StyledWrapper
                                css={css`
                                    width: 100%;
                                    display: flex;
                                    margin: 0 auto;
                                `}
                            >
                                <StyledWrapper
                                    css={css`
                                        width: 75%;
                                        @media all and (min-width: 992px) and (max-width: 1024px) {
                                            width: 72%;
                                        }
                                    `}
                                >
                                    <GridContainer
                                        {...styles.megaMenuGridContainer}
                                        offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                                    >
                                        {isCustom ? (
                                            <StyledWrapper
                                                css={css`
                                                    width: 100%;
                                                    min-height: 150px;
                                                `}
                                            >
                                                {" "}
                                                <Zone contentId={this.props.id} zoneName={`${link.title}1`}></Zone>
                                            </StyledWrapper>
                                        ) : (
                                            <>
                                                {link
                                                    .children!.filter(child => !child.excludeFromNavigation)
                                                    .map((child, index) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <GridItem
                                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                                            // eslint-disable-next-line react/no-array-index-key
                                                            key={index}
                                                            {...styles.megaMenuGridItem}
                                                            as="li"
                                                        >
                                                            <Link
                                                                {...styles.megaMenuHeading}
                                                                href={child?.url}
                                                                onClick={this.hoverOff}
                                                            >
                                                                {child.title}
                                                            </Link>
                                                            {child.children && (
                                                                <ul
                                                                    className="subCategoriesLink"
                                                                    data-test-selector={`linksFor_${child.title}`}
                                                                >
                                                                    {child.children
                                                                        .filter(
                                                                            grandChild =>
                                                                                !grandChild.excludeFromNavigation,
                                                                        )
                                                                        .map((grandChild, index) => (
                                                                            // eslint-disable-next-line react/no-array-index-key
                                                                            <li key={index}>
                                                                                <Link
                                                                                    {...styles.megaMenuLink}
                                                                                    onClick={this.hoverOff}
                                                                                    href={grandChild?.url}
                                                                                    data-test-selector={
                                                                                        grandChild.title
                                                                                    }
                                                                                >
                                                                                    {grandChild.title}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                </ul>
                                                            )}
                                                        </GridItem>
                                                    ))}
                                                {link.shopAllProduct && (
                                                    <GridItem key={index} {...styles.megaMenuGridItem} as="li">
                                                        <Link
                                                            {...styles.megaMenuHeading}
                                                            onClick={this.hoverOff}
                                                            href={link.url}
                                                        >
                                                            {link.shopAllProductLabel
                                                                ? `${link.shopAllProductLabel} ${link.title}`
                                                                : `Shop All ${link.title}`}
                                                        </Link>
                                                    </GridItem>
                                                )}
                                                {emptyLi && emptyLi.length ? emptyLi : null}
                                            </>
                                        )}
                                    </GridContainer>
                                </StyledWrapper>
                                <StyledWrapper
                                    id="last_col_zone"
                                    {...(isMega
                                        ? { ...styles.paddingCustomMenu }
                                        : { ...styles.paddingCustomMegaMenu })}
                                >
                                    <Zone contentId={this.props.id} zoneName={link.title}></Zone>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}

                        {/* <StyledWrapper {...styles.viewAllCategoriesWrapper}>
                            <StyledWrapper {...styles.viewAllCategories}>
                                 <Link
                                    onClick={this.hoverOff}
                                    typographyProps={styles.viewAllTypography}
                                    href={viewAllCategoryLink!.url}
                                >
                                    View All Categories
                                </Link> 
                            </StyledWrapper>
                        </StyledWrapper> */}
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        return menuItem;
    }
}

export default withTheme(MainNavigationItem);
